[
  {
    "id": "eau-plate",
    "name": "Eau plate",
    "aliases": ["eau", "eau minerale"],
    "category_key": "boissons",
    "unit_label": "bouteille",
    "pack_size": 6,
    "contents_qty": 1.5,
    "contents_unit": "l",
    "rate_qty": 2,
    "rate_per_days": 3
  },
  {
    "id": "eau-gazeuse",
    "name": "Eau gazeuse",
    "aliases": ["eau petillante"],
    "category_key": "boissons",
    "unit_label": "bouteille",
    "pack_size": 6,
    "contents_qty": 1,
    "contents_unit": "l",
    "rate_qty": 1,
    "rate_per_days": 2
  },
  {
    "id": "jus-orange",
    "name": "Jus d'orange",
    "aliases": ["jus"],
    "category_key": "boissons",
    "unit_label": "brique",
    "pack_size": 1,
    "contents_qty": 1,
    "contents_unit": "l",
    "rate_qty": 1,
    "rate_per_days": 7
  },
  {
    "id": "jus-pomme",
    "name": "Jus de pomme",
    "category_key": "boissons",
    "unit_label": "brique",
    "pack_size": 1,
    "contents_qty": 1,
    "contents_unit": "l",
    "rate_qty": 1,
    "rate_per_days": 10
  },
  {
    "id": "soda-cola",
    "name": "Soda au cola",
    "aliases": ["coca", "cola"],
    "category_key": "boissons",
    "unit_label": "bouteille",
    "pack_size": 1,
    "contents_qty": 1.5,
    "contents_unit": "l",
    "rate_qty": 1,
    "rate_per_days": 7
  },
  {
    "id": "limonade",
    "name": "Limonade",
    "category_key": "boissons",
    "unit_label": "bouteille",
    "pack_size": 1,
    "contents_qty": 1.5,
    "contents_unit": "l",
    "rate_qty": 1,
    "rate_per_days": 14
  },
  {
    "id": "the-glace",
    "name": "Thé glacé",
    "aliases": ["ice tea"],
    "category_key": "boissons",
    "unit_label": "bouteille",
    "pack_size": 1,
    "contents_qty": 1.5,
    "contents_unit": "l",
    "rate_qty": 1,
    "rate_per_days": 14
  },
  {
    "id": "sirop",
    "name": "Sirop",
    "aliases": ["sirop de grenadine", "sirop de menthe"],
    "category_key": "boissons",
    "unit_label": "bouteille",
    "pack_size": 1,
    "contents_qty": 75,
    "contents_unit": "cl",
    "rate_qty": 1,
    "rate_per_days": 30
  },
  {
    "id": "boisson-vegetale",
    "name": "Boisson végétale",
    "aliases": ["lait d amande", "lait d avoine", "lait de soja"],
    "category_key": "boissons",
    "unit_label": "brique",
    "pack_size": 1,
    "contents_qty": 1,
    "contents_unit": "l",
    "rate_qty": 1,
    "rate_per_days": 7
  },
  {
    "id": "biere",
    "name": "Bière",
    "aliases": ["bieres"],
    "category_key": "boissons",
    "unit_label": "bouteille",
    "pack_size": 6,
    "contents_qty": 25,
    "contents_unit": "cl",
    "rate_qty": 3,
    "rate_per_days": 7
  },
  {
    "id": "vin-rouge",
    "name": "Vin rouge",
    "aliases": ["vin"],
    "category_key": "boissons",
    "unit_label": "bouteille",
    "pack_size": 1,
    "contents_qty": 75,
    "contents_unit": "cl",
    "rate_qty": 1,
    "rate_per_days": 7
  },
  {
    "id": "vin-blanc",
    "name": "Vin blanc",
    "category_key": "boissons",
    "unit_label": "bouteille",
    "pack_size": 1,
    "contents_qty": 75,
    "contents_unit": "cl",
    "rate_qty": 1,
    "rate_per_days": 14
  },
  {
    "id": "vin-rose",
    "name": "Vin rosé",
    "category_key": "boissons",
    "unit_label": "bouteille",
    "pack_size": 1,
    "contents_qty": 75,
    "contents_unit": "cl",
    "rate_qty": 1,
    "rate_per_days": 14
  },
  {
    "id": "champagne",
    "name": "Champagne",
    "aliases": ["cremant"],
    "category_key": "boissons",
    "unit_label": "bouteille",
    "pack_size": 1,
    "contents_qty": 75,
    "contents_unit": "cl"
  }
]
